import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TraceabilityComponent } from './traceability.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [TraceabilityComponent]
})
export class TraceabilityModule { }
